import React, {useState, useEffect} from "react";
import DatePicker from "react-datepicker";

import "./ProblemFour.css";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import topicAreaIcon from "../../../../../resources/images/topic-area-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {creatProblem} from "../../../../../services/ProblemService";
import {updateProblem} from "../../../../../services/ProblemService";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {convertDateToUTC} from "../../../../../util/DateUtil";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";

export const ProblemFour = ({context, setContext, navigateTo, navigateBack, setSpinnerText, showToaster, toolTipsEnabled}) => {

    const [toImprove, setToImprove] = useState("");
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [byDate, setByDate] = useState(null);
    const [percentage, setPercentage] = useState(false);

    const calculateMedian = (values) => {
        if (values.length === 0) return 0;

        values.sort(function (a, b) {
            return a - b;
        });

        const half = Math.floor(values.length / 2);

        if (values.length % 2)
            return values[half];

        return Math.round((values[half - 1] + values[half]) / 2.0);
    }

    useEffect(() => {
        setToImprove(context.topicAreaScreen.indicator.outcomeMeasure);

        const outcomeMeasureBaselines = context.problemScreen.baselines;
        if (outcomeMeasureBaselines && outcomeMeasureBaselines.length > 5) {
            if (outcomeMeasureBaselines[0].type === "Percentage") {
                setPercentage(true);
            }
            const filteredOutcomeMeasureBaselines = outcomeMeasureBaselines.filter((baseline) => baseline.value && baseline.isInitial);
            const values = filteredOutcomeMeasureBaselines.map((dataPointValue) => {
                return parseInt(dataPointValue.value);
            })
            const median = calculateMedian(values);
            setFrom(median);
        }
    }, []);

    useEffect(() => {
        if (context.problemScreen) {
            if (context.problemScreen.to) {
                setTo(context.problemScreen.to);
            }

            if (context.problemScreen.byDate) {
                setByDate(new Date(context.problemScreen.byDate));
            }
        }
    }, [context]);

    const handleToChange = ({target}) => {
        let {value} = target;
        if (percentage) {
            value = value.slice(0, value.length - 1)
        }

        if (/^[0-9]*$/.test(value)) {
            setTo(value);
        }
    }

    const handleInputClick = ({target}) => {
        if (percentage) {
            const {value} = target;
            target.selectionStart = value.length - 1;
            target.selectionEnd = value.length - 1;
        }
    }

    const handleNextClick = async () => {
        const copyOfOutcomeMeasureBaselines = JSON.parse(JSON.stringify(context.problemScreen.baselines));
        const filteredBaselines = copyOfOutcomeMeasureBaselines.filter((baseline) => baseline.value);

        const mappedBaselines = filteredBaselines.map((baseline) => {
            return {...baseline, date: convertDateToUTC(baseline.date), isInitial: baseline.isInitial};
        });

        const problemToBeSaved = {
            externalReference: context.problemScreen.externalReference,
            topicAreaExternalRef: context.topicAreaScreen.topicArea.externalReference,
            locationExternalRef: context.facilityScreen.locationExternalReference,
            visitExternalRef: context.topicAreaScreen.visitExternalReference,
            name: context.problemScreen.title,
            description: context.problemScreen.description,
            reviewFrequency: context.problemScreen.frequency.label,
            aimStatementVO: {
                toImprove: toImprove,
                from: from,
                to: to,
                by: convertDateToUTC(byDate),
            },
            outcomeMeasureBaselines: mappedBaselines,
            levelOfSupport: context.facilityScreen.levelOfSupport.label,
            grantExternalRef: context.topicAreaScreen.grant.externalReference,
            dateOfNextVisit: convertDateToUTC(context.problemScreen.nextVisitDate),
        };

        await saveProblem(problemToBeSaved);
    }

    const saveProblem = async (problemToBeSaved) => {
        setSpinnerText("Saving Problem");
        const problemExternalReference = problemToBeSaved.externalReference;
        if (problemExternalReference === undefined || problemExternalReference === null) {
            const [data, error] = await creatProblem(context.username, problemToBeSaved);
            if (data) {
                if (data.responseStatus === "Success") {
                    const savedProblemExtRef = data.savedProblemVO.externalReference;
                    setContext((prevState) => ({
                        ...prevState,
                        problemScreen: {
                            ...prevState.problemScreen,
                            externalReference: savedProblemExtRef,
                            toImprove,
                            from,
                            to,
                            byDate,
                        }
                    }));
                    navigateTo("problemFive");
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        } else {
            const copyOfProblemScreen = context.copyOfProblemScreen;
            const currentProblemScreen = JSON.stringify(context.problemScreen);
            let byDateUnchanged = true;
            if (byDate.toISOString() !== new Date(context.problemScreen.byDate).toISOString()) {
                byDateUnchanged = false;
            }
            if (copyOfProblemScreen === currentProblemScreen && context.problemScreen.to === to && byDateUnchanged) {
                navigateTo("problemFive");
            } else {
                const [data, error] = await updateProblem(context.username, problemToBeSaved);
                if (data) {
                    if (data.responseStatus === "Success") {
                        setContext((prevState => ({
                            ...prevState,
                            problemScreen: {
                                ...prevState.problemScreen,
                                toImprove,
                                from,
                                to,
                                byDate,
                            }
                        })));
                        navigateTo("problemFive");
                    }
                    showToaster(data);
                } else {
                    showToaster({
                        responseStatus: "Error",
                        responseMessage: error.message,
                    });
                }
            }
        }
        setSpinnerText(null);
    }

    const isButtonDisabled = () => {
        return (!toImprove || toImprove === "" || from === "" || !to || to === "" || !byDate);
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={topicAreaIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.topicAreaScreen.topicArea.topicArea}</p>
                </div>
                <div className="wizard-right-container">
                    <div className={"label-div-tooltip"}>
                        <label className="label">Problem Aim Statement:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"problemaimstatement123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText}
                                 showToaster={showToaster}
                                 fieldName={"Problem Aim Statement:"}/>}
                    </div>
                    <div className="input-container-left-label">
                        <label>To Improve:</label>
                        <input className="text-input"
                               disabled={true}
                               defaultValue={toImprove}
                               data-testid="to-improve-input"/>
                    </div>
                    <div className="input-container-left-label">
                        <label>From:</label>
                        <input className="text-input"
                               disabled={true}
                               value={from + (percentage ? "%" : "")}
                               data-testid="from-input"/>
                    </div>
                    <div className="input-container-left-label">
                        <label>To:</label>
                        <input className="text-input"
                               disabled={!context.editMode}
                               onChange={handleToChange}
                               onClick={handleInputClick}
                               value={to + (percentage ? "%" : "")}
                               data-testid="to-input"/>
                    </div>
                    <div className="input-container-left-label">
                        <label>By:</label>
                        <DatePicker selected={byDate} disabled={!context.editMode} onChange={(selectedDate) => {
                            setByDate(selectedDate);
                        }} className="text-input" showPopperArrow={false} dateFormat='dd/MM/yyyy'/>
                    </div>
                    {context.viewMode &&
                    <CommentToolTip contextName={"Problem"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.problemToBeViewedExternalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
